
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      activeFilter: ``,
      players: [], // Data from API
      formattedPlayers: [], // Data with team attached
      noSquadFound: false,
    };
  },
  computed: {
    teamsConfig () {
      return this.post?.acf?.squad_config?.team?.team ?? null;
    },
    seasonsConfig () {
      return this.post?.acf?.squad_config?.season?.season ?? null;
    },
    playerPositions () {
      return this.formattedPlayers.map(playerSquad => playerSquad.player.position);
    },
    loanPlayers () {
      return this.formattedPlayers.filter(playerSquad => playerSquad.player.onLoanTo !== null || playerSquad.player.onLoanFrom !== null);
    },
    positionFilters () {
      return this.$store.state.config.squad_filters;
    },
    dfpOptions () {
      return this.$store.state.config.squad_dfp;
    },
    outputPlayers () {
      if (this.formattedPlayers.length) {
        let players = this.sortPlayerNumber([...this.formattedPlayers]);
        if (this.activeFilter) {
          if (this.activeFilter === `onLoan`) {
            players = players.filter(playerSquad => playerSquad.player.onLoanTo !== null || playerSquad.player.onLoanFrom !== null);
          } else {
            players = players.filter(playerSquad => this.activeFilter.includes(playerSquad.player.position));
          }
        }

        if (this.dfpOptions?.show_dfp) {
          const dfpItem = {
            dfp_item: this.dfpOptions.dfp_item,
            position: this.dfpOptions.dfp_position,
          };
          players.splice(parseInt(this.dfpOptions.dfp_position) - 1, 0, dfpItem);
        }

        return players;
      }
      return [];
    },
  },
  mounted () {
    if (this.teamsConfig && this.seasonsConfig) {
      this.getSquadData();
    }
  },
  methods: {
    setFilter (filter) {
      this.activeFilter = filter;
    },
    async getSquadData () {
      const params = {
        include: `team,playerSquads.player.images,playerSquads.player.country.images`,
        filter: {
          "teamId": this.parseIdsFromTeamConfig(),
          "seasonId": this.parseIdsFromSeasonConfig(),
        },
        filterIncludes: {
          "playerSquads.player.images.description": `headshot`,
        },
      };

      const response = await this.$getStats(`squad`, params);
      if (response) {
        this.players = response.data;
        this.formatPlayers();
      } else {
        this.noSquadFound = true;
      }
    },
    formatPlayers () {
      const players = [...this.players];
      this.formattedPlayers = players.flatMap(squad => squad.playerSquads.map(squadPlayer => ({
        team: squad.team,
        player: squadPlayer,
      })));
    },
    sortPlayerNumber () {
      const hasNum = this.formattedPlayers.filter(player => player.player.squadNumber !== null);
      const noNum = this.formattedPlayers.filter(player => player.player.squadNumber === null);

      const hasNumSorted = hasNum.sort((a, b) => parseInt(a.player.squadNumber) - parseInt(b.player.squadNumber));
      const noNumSorted = noNum
        .sort((a, b) => a.player.player.firstName.localeCompare(b.player.player.firstName))
        .sort((a, b) => a.player.player.lastName.localeCompare(b.player.player.lastName));
      return [...hasNumSorted, ...noNumSorted];
    },
    parseIdsFromTeamConfig () {
      if (this.teamsConfig) {
        const teamIds = this.teamsConfig.map(({ id }) => (id));
        return teamIds.join(`||`);
      }
    },
    parseIdsFromSeasonConfig () {
      if (this.seasonsConfig) {
        const seasonIds = this.seasonsConfig.map(({ id }) => (id));
        return seasonIds.join(`||`);
      }
    },
    getTeamName (team) {
      return team?.teamNames[0]?.displayName ?? ``;
    },
  },
};
